import React from 'react';

export default function Header({ date, puzzleNumber, user, onSignIn, onSignOut, onProfile, onHowToPlay }) {
  const formatted = new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="text-center mb-6 w-full max-w-lg">
      {/* Auth controls - above title */}
      <div className="flex items-center justify-end gap-2 mb-2">
        {onHowToPlay && (
          <button
            onClick={onHowToPlay}
            className="text-sm text-ink-faint font-body hover:text-ink transition-colors mr-auto"
            aria-label="How to play"
          >
            ?
          </button>
        )}
        {user ? (
          <>
            <span className="text-sm font-body text-ink" title={`Max streak: ${user.maxStreak}`}>
              {'\uD83D\uDD25'} {user.currentStreak}
            </span>
            <button
              onClick={onProfile}
              className="text-sm font-body text-ink font-semibold hover:underline transition-colors"
            >
              {user.displayName}
            </button>
            <button
              onClick={onSignOut}
              className="text-xs text-ink-faint font-body hover:text-ink transition-colors"
            >
              Sign out
            </button>
          </>
        ) : (
          <button
            onClick={onSignIn}
            className="text-sm text-ink-faint font-body hover:text-ink transition-colors underline"
          >
            Sign in
          </button>
        )}
      </div>

      <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif font-black tracking-tight text-ink">
        Approximate Grid
      </h1>
      <div className="w-32 mx-auto border-t-2 border-ink mt-2 mb-1" />
      <p className="text-sm text-ink-light font-body italic">
        {puzzleNumber ? `Puzzle #${puzzleNumber} \u2022 ` : ''}{formatted}
      </p>
    </div>
  );
}
